<template>
  <section class="wc-page">
    <!-- Hero de conexión -->
    <div class="wc-hero">
      <div class="wc-hero__icon">
        <span class="wc-hero__woo-text">Woo</span>
      </div>
      <div class="wc-hero__info">
        <h4 class="wc-hero__title">WooCommerce</h4>
        <p class="wc-hero__url">
          {{ form.woocommerce_store_url || "Sin configurar" }}
        </p>
      </div>
      <span
        class="wc-hero__badge"
        :class="
          form.woocommerce_store_url
            ? 'wc-hero__badge--connected'
            : 'wc-hero__badge--pending'
        "
      >
        <i
          :class="
            form.woocommerce_store_url
              ? 'el-icon-check'
              : 'el-icon-warning-outline'
          "
        ></i>
        {{ form.woocommerce_store_url ? "Conectado" : "Sin configurar" }}
      </span>
    </div>

    <el-form :model="form" :rules="rules" ref="form">
      <!-- Sección 1: Tienda -->
      <div class="wc-card">
        <div class="wc-card__header">
          <i class="el-icon-link wc-card__header-icon"></i>
          <span>Conexión</span>
        </div>
        <div class="wc-card__body">
          <b-row>
            <b-col xs="12" md="8">
              <el-form-item prop="woocommerce_store_url">
                <label class="wc-label">URL de la tienda</label>
                <el-input
                  v-model="form.woocommerce_store_url"
                  placeholder="https://mitienda.com"
                  prefix-icon="el-icon-link"
                  class="wc-input"
                />
              </el-form-item>
            </b-col>
            <b-col xs="12" md="4">
              <el-form-item prop="woocommerce_emision_point">
                <SelectEmissionPointsComponent
                  @onChangeSelect="onChangeSelectEmissionPoints"
                  :setEmissionPointId="form.woocommerce_emision_point"
                />
              </el-form-item>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- Sección 2: Credenciales -->
      <div class="wc-card">
        <div class="wc-card__header">
          <i class="el-icon-key wc-card__header-icon"></i>
          <span>Credenciales API</span>
          <span class="wc-card__header-hint"
            >Generadas en WooCommerce → Ajustes → Avanzado → API REST</span
          >
        </div>
        <div class="wc-card__body">
          <b-row>
            <b-col xs="12" md="6">
              <el-form-item prop="woocommerce_consumer_key">
                <label class="wc-label">API Key (Consumer Key)</label>
                <el-input
                  v-model="form.woocommerce_consumer_key"
                  placeholder="ck_xxxxxxxxxxxxxxxx"
                  type="password"
                  show-password
                  class="wc-input"
                />
              </el-form-item>
            </b-col>
            <b-col xs="12" md="6">
              <el-form-item prop="woocommerce_consumer_secret">
                <label class="wc-label">Secret Key (Consumer Secret)</label>
                <el-input
                  v-model="form.woocommerce_consumer_secret"
                  placeholder="cs_xxxxxxxxxxxxxxxx"
                  type="password"
                  show-password
                  class="wc-input"
                />
              </el-form-item>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- Sección 3: Sincronización -->
      <div class="wc-card">
        <div class="wc-card__header">
          <i class="el-icon-refresh wc-card__header-icon"></i>
          <span>Sincronización</span>
        </div>
        <div class="wc-card__body">
          <b-row class="align-items-start">
            <b-col xs="12" md="7">
              <div class="wc-toggle-row">
                <div class="wc-toggle-content">
                  <span class="wc-toggle-title"
                    >Firmado digital automático</span
                  >
                  <span class="wc-toggle-desc"
                    >Firma y envía al SRI las facturas de WooCommerce
                    automáticamente</span
                  >
                </div>
                <el-switch
                  v-model="form.woocommerce_is_sync_invoices"
                  active-color="#3ecfb4"
                />
              </div>
              <div class="wc-toggle-row mt-3">
                <div class="wc-toggle-content">
                  <span class="wc-toggle-title">Importar órdenes</span>
                  <span class="wc-toggle-desc"
                    >Sincroniza productos, categorías, clientes y órdenes desde
                    tu tienda</span
                  >
                </div>
                <el-switch
                  v-model="form.woocommerce_is_sync_orders"
                  active-color="#3ecfb4"
                />
              </div>
            </b-col>
            <b-col xs="12" md="5">
              <InputDatePickerComponent
                @onChangeDatePicker="onChangeDatePicker"
                prop="woocommerce_sync_date"
                placeholder=""
                title="Sincronizar desde"
                :setDate="form.woocommerce_sync_date"
                :isDisabledDate="true"
              />
            </b-col>
          </b-row>

          <div class="wc-actions">
            <ButtonPrimaryComponent
              title="Guardar configuración"
              @onSaveClick="handleSaveClick"
            />
            <ButtonComponent
              className="btn md__btn-third-secondary wc-btn-sync"
              title="Sincronizar ahora"
              @onSaveClick="handleSinconizar"
            />
          </div>
        </div>
      </div>
    </el-form>

    <!-- Sección 4: Historial -->
    <div class="wc-card">
      <div class="wc-card__header">
        <i class="el-icon-document wc-card__header-icon"></i>
        <span>Historial de sincronización</span>
        <div class="wc-card__header-actions">
          <el-button
            size="mini"
            icon="el-icon-refresh"
            :loading="logsLoading"
            circle
            @click="fetchLogs"
            title="Actualizar"
          />
          <el-button
            v-if="logs.length > 0"
            size="mini"
            type="danger"
            plain
            @click="handleClearLogs"
            >Limpiar</el-button
          >
        </div>
      </div>

      <div key="log-loading" v-if="logsLoading" class="wc-log-state">
        <i class="el-icon-loading" style="font-size:24px;color:#3ecfb4"></i>
        <p>Cargando historial...</p>
      </div>

      <div key="log-empty" v-else-if="logs.length === 0" class="wc-log-state">
        <i class="el-icon-document" style="font-size:34px;color:#dcdfe6"></i>
        <p>Sin registros de sincronización aún</p>
      </div>

      <div key="log-list" v-else class="wc-log-list">
        <div v-for="log in logs" :key="log.id" class="wc-log-item">
          <span class="wc-log-dot" :class="'wc-log-dot--' + log.status">
            <i :class="getLogIcon(log.status)"></i>
          </span>
          <div class="wc-log-body">
            <div class="wc-log-meta">
              <span class="wc-log-badge" :class="'wc-log-badge--' + log.type">{{
                getTypeLabel(log.type)
              }}</span>
              <span v-if="log.reference" class="wc-log-ref"
                >#{{ log.reference }}</span
              >
              <span class="wc-log-time">{{
                formatLogDate(log.created_at)
              }}</span>
            </div>
            <p class="wc-log-msg">{{ log.message }}</p>
          </div>
        </div>
      </div>

      <div v-if="logs.length > 0" class="wc-log-footer">
        {{ logs.length }} registros · Se limpia automáticamente cada semana
      </div>
    </div>
  </section>
</template>

<script>
import Validate from "@/assets/validate";
import ButtonPrimaryComponent from "@/modules/dashboard/components/ButtonPrimary";
import ButtonComponent from "@/modules/dashboard/components/Button";
import SelectEmissionPointsComponent from "../../../../components/SelectEmissionPoints";
import InputDatePickerComponent from "@/modules/dashboard/components/InputDatePicker";
import tradeService from "../../../services/tradeService";
import moment from "moment";

const DATE_AT = moment().format("YYYY-MM-DD");

export default {
  name: "WoocommerceAdd",
  data() {
    return {
      form: {
        business_id: "",
        woocommerce_store_url: "",
        woocommerce_consumer_key: "",
        woocommerce_consumer_secret: "",
        woocommerce_is_sync_invoices: false,
        woocommerce_is_sync_orders: false,
        woocommerce_emision_point: "",
        woocommerce_sync_date: DATE_AT
      },
      rules: {
        woocommerce_store_url: [Validate.rules.required()],
        woocommerce_consumer_key: [Validate.rules.required()],
        woocommerce_consumer_secret: [Validate.rules.required()],
        woocommerce_sync_date: [Validate.rules.required()]
      },
      logs: [],
      logsLoading: false
    };
  },
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    async getIntegrationsWoocommerce() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await tradeService
          .getIntegrationsWoocommerce({
            params: { business_id: this.getUser.user_business.id }
          })
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        const { success, data } = response.data;
        if (success) {
          this.form = { ...this.form, ...data };
        }
      } catch {
        return false;
      }
    },
    handleSaveClick() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.$store.dispatch("toggleRequestLoading");
        try {
          this.form.business_id = this.getUser.user_business.id;
          let response = await tradeService
            .addIntegrationsWoocommerce(this.form)
            .finally(() => this.$store.dispatch("toggleRequestLoading"));
          const { success, message } = response.data;
          if (success) this.$notifications.success({ message });
        } catch {
          return false;
        }
      });
    },
    async handleSinconizar() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        this.form.business_id = this.getUser.user_business.id;
        let response = await tradeService
          .SyncIntegrationsWoocommerce({})
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({ message });
          this.fetchLogs();
        }
      } catch {
        return false;
      }
    },
    async fetchLogs() {
      this.logsLoading = true;
      try {
        const response = await tradeService.getWoocommerceLogs();
        const { success, data } = response.data;
        if (success) this.logs = data;
      } catch {
        // silencioso
      } finally {
        this.logsLoading = false;
      }
    },
    async handleClearLogs() {
      try {
        const response = await tradeService.clearWoocommerceLogs();
        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({ message });
          this.logs = [];
        }
      } catch {
        return false;
      }
    },
    getLogIcon(status) {
      return (
        {
          success: "el-icon-check",
          failed: "el-icon-close",
          timeout: "el-icon-time",
          warning: "el-icon-warning-outline",
          info: "el-icon-info"
        }[status] || "el-icon-info"
      );
    },
    getTypeLabel(type) {
      return (
        {
          order: "Orden",
          product: "Producto",
          invoice: "Factura",
          sync: "Sincronización",
          webhook: "Webhook"
        }[type] || type
      );
    },
    formatLogDate(dateStr) {
      return dateStr ? moment(dateStr).fromNow() : "";
    },
    onChangeSelectEmissionPoints({ emissionPointId }) {
      this.form.woocommerce_emision_point = emissionPointId;
    },
    onChangeDatePicker({ date }) {
      this.form.woocommerce_sync_date = date;
    }
  },
  components: {
    ButtonPrimaryComponent,
    SelectEmissionPointsComponent,
    InputDatePickerComponent,
    ButtonComponent
  },
  mounted() {
    this.getIntegrationsWoocommerce();
    this.fetchLogs();
  }
};
</script>

<style lang="scss" scoped>
.wc-page {
  padding: 0 8px 32px;
}

/* ── Hero ── */
.wc-hero {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  background: #f8f9ff;
  border: 1.5px solid #e8eaf0;
  border-radius: 14px;
  margin-bottom: 16px;
}
.wc-hero__icon {
  width: 46px;
  height: 46px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}
.wc-hero__woo-text {
  font-size: 13px;
  font-weight: 800;
  color: #7f54b3;
  letter-spacing: -0.5px;
}
.wc-hero__info {
  flex: 1;
  min-width: 0;
}
.wc-hero__title {
  font-size: 15px;
  font-weight: 700;
  color: #2d2b55;
  margin: 0 0 2px;
}
.wc-hero__url {
  font-size: 12px;
  color: #909399;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wc-hero__badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 20px;
  flex-shrink: 0;

  &--connected {
    background: #e6f9f4;
    color: #1d9e75;
  }
  &--pending {
    background: #fdf6ec;
    color: #e6a23c;
  }
}

/* ── Cards ── */
.wc-card {
  background: #fff;
  border: 1.5px solid #ebeef5;
  border-radius: 14px;
  margin-bottom: 14px;
  overflow: hidden;
}
.wc-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f2f5;
  font-size: 14px;
  font-weight: 600;
  color: #2d2b55;
}
.wc-card__header-icon {
  font-size: 15px;
  color: #3ecfb4;
}
.wc-card__header-hint {
  font-size: 11px;
  font-weight: 400;
  color: #c0c4cc;
  margin-left: 4px;
}
.wc-card__header-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}
.wc-card__body {
  padding: 20px;
}

/* ── Form elements ── */
.wc-label {
  font-size: 12px;
  font-weight: 600;
  color: #606266;
  display: block;
  margin-bottom: 6px;
}
.wc-input {
  ::v-deep .el-input__inner {
    border: 1.5px solid #dcdfe6;
    border-radius: 10px;
    height: 42px;
    font-size: 13px;
    transition: border-color 0.2s;
    &:focus {
      border-color: #3ecfb4;
    }
  }
  ::v-deep .el-input__prefix {
    display: flex;
    align-items: center;
  }
}
/* ── Toggles ── */
.wc-toggle-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  background: #fafbff;
  border: 1.5px solid #ebeef5;
  border-radius: 10px;
}
.wc-toggle-content {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.wc-toggle-title {
  font-size: 13px;
  font-weight: 600;
  color: #2d2b55;
}
.wc-toggle-desc {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

/* ── Actions ── */
.wc-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f0f2f5;
}
.wc-btn-sync {
  border-radius: 10px !important;
}

/* ── Log list ── */
.wc-log-state {
  text-align: center;
  padding: 36px 20px;
  color: #909399;
  font-size: 13px;
  p {
    margin: 8px 0 0;
  }
}
.wc-log-list {
  max-height: 400px;
  overflow-y: auto;
}
.wc-log-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 13px 20px;
  border-bottom: 1px solid #f5f7fa;
  transition: background 0.15s;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: #fafbff;
  }
}
.wc-log-dot {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 700;
  margin-top: 1px;

  &--success {
    background: #e6f9f4;
    color: #1d9e75;
  }
  &--failed {
    background: #fef0f0;
    color: #f56c6c;
  }
  &--timeout {
    background: #fdf6ec;
    color: #e6a23c;
  }
  &--warning {
    background: #fdf6ec;
    color: #e6a23c;
  }
  &--info {
    background: #ecf5ff;
    color: #409eff;
  }
}
.wc-log-body {
  flex: 1;
  min-width: 0;
}
.wc-log-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 4px;
}
.wc-log-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 9px;
  border-radius: 20px;

  &--order {
    background: #ecf5ff;
    color: #409eff;
  }
  &--product {
    background: #f0f9eb;
    color: #67c23a;
  }
  &--invoice {
    background: #f3e8ff;
    color: #9333ea;
  }
  &--sync {
    background: #e6f9f4;
    color: #1d9e75;
  }
  &--webhook {
    background: #fdf6ec;
    color: #e6a23c;
  }
}
.wc-log-ref {
  font-size: 12px;
  color: #909399;
}
.wc-log-time {
  font-size: 11px;
  color: #c0c4cc;
  margin-left: auto;
  white-space: nowrap;
}
.wc-log-msg {
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
  margin: 0;
}
.wc-log-footer {
  padding: 10px 20px;
  font-size: 11px;
  color: #c0c4cc;
  text-align: right;
  border-top: 1px solid #f0f2f5;
}
</style>
